import "./Footer.scss";
import TextBlock from "../../components/ui/TextBlock";
import Button from "../../components/ui/Button";

function Footer() {
	return (
		<footer>
			<div className="footer-container">
				<div className="columns-container">
					<div className="column">
						<TextBlock
							title={
								<>
									Ready to grow your JLR <br /> dealership?
								</>
							}
							type="h1"
							color="white"
							align="left"
						/>
					</div>
					<div className="column">
						<div className="buttons-container">
							<Button
								link="/enroll"
								styleName="white"
								size="large">
								Enroll now
							</Button>
							<Button
								link="/#channels"
								styleName="outlineWhite"
								size="large">
								Learn more
							</Button>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
